<template>
  <section v-if="!isRegDone" class="form-section">
    <div v-if="!isO2o" class="form-section__head">
      <h3>약관동의</h3>
    </div>
    <div v-else class="form-section__head">
      <h3>중고폰 판매를 위한 약관동의</h3>
    </div>
    <div>
      <div style="margin-bottom: 20px">
        <div
          class="check-wrap row agrm-form-input-area"
          style="border-bottom: 1px solid #e9e9e9"
        >
          <DxCheckBox
            text="판매 유의사항 전체동의"
            v-model="allAgrm"
            @valueChanged="handleAllAgrm"
            width="100%"
          />
          <span
            id="toggle_cont"
            :style="{ transform: isShowDetail ? '' : 'scaleY(-1)' }"
            @click="isShowDetail = !isShowDetail"
          >
          </span>
        </div>
      </div>
      <transition name="slide-up">
        <div
          v-if="isShowDetail"
          style="padding-left: 20px; padding-right: 20px"
        >
          <div
            v-for="(obj, idx) in getTermsContents"
            :key="`terms-contents-${idx}`"
            class="agree-row"
          >
            <div>
              <input type="checkbox" id="agree1" class="ui-checkbox" />
              <label class="ui-label" for="agree1" @click.prevent="obj.isActive = !obj.isActive">
                <span
                  :class="{ 'ui-checkbox-object': true, active: obj.isActive }"
                ></span>
                <span :class="{ 'font-bold': obj.isActive }">
                  <span v-html="obj.title"></span>
                  <span v-if="obj.isRequired" class="font-red">(필수)</span>
                </span>
                <span v-if="obj.isDetaill" style="margin-left: 3px;">
                  <a href="javascript:void(0)" class="show-detail" @click.stop="detailPopup(obj)"><u style='color:#999;'>자세히 보기</u></a>
                </span>
              </label>
            </div>
            <a
              v-if="obj.link"
              href="javascript:"
              class="agree-row__link"
              @click="openDetailPopup"
            >
              <span class="for-a11y">내용 보기</span>
            </a>
            <div v-else class="terms-contents" v-html="obj.terms">
            </div>
          </div>
        </div>
      </transition>
    </div>
    <TermsPopup />
    <DetailPopup/>
  </section>
</template>

<script>
import { DxCheckBox } from "devextreme-vue/check-box";

import TermsPopup from "./TermsPopup.vue";
import DetailPopup from "./DetailPopup.vue";

export default {
  name: "Terms",
  components: {
    DxCheckBox,
    TermsPopup,
    DetailPopup,
  },
  props: ["ordInfo", "isRegDone","isO2o"],
  data: () => ({
    allAgrm: false,
    isShowDetail: true,
    termsContents: [
      {
        title: "개인정보의 수집 및 이용동의",
        isRequired: true,
        //link: 'a',
        terms:
          "개인정보의 수집ㆍ이용 목적 : 중고폰 판매에 따른 대금 지급,수집하는 개인정보의 항목 : (필수) 이름, 은행명, 계좌번호 (선택) 이벤트 쿠폰번호, 개인정보의 보유ㆍ이용 기간 : 수집일로 부터 5년, 귀하께서는 본 안내에 따른 개인정보 수집. 이용에 대하여 동의를 거부 할 권리가 있습니다. 다만, 동의를 거부하는 경우에 중고폰 판매가 불가할 수 있음을 알려드립니다",
        isActive: false,
        isCommon: true,
      },
      {
        title: "도난/분실 제품 처리 동의",
        isRequired: true,
        terms: `판매 신청한 제품이 도난/분실 등록된 제품일 경우 판매가 취소되고 법적 조치를 취합니다.`,
        isActive: false,
        isCommon: true,
      },
      {
        title: "침수, 고장 제품 처리 동의",
        isRequired: true,
        terms: `판매 신청한 제품이 침수 이력이 있거나 심각한 고장이 있는 경우(제품 파손으로 작동이 되지 않거나, 하드웨어 Board가 불량인 경우, 전원이 들어오지 않는 경우) 판매 취소되어 반품되거나, 지급된 대금의 일부 또는 전부를 환불하는 것에 동의합니다.`,
        isActive: false,
        isCommon: false,
      },
      {
        title: "계정 삭제 협조 동의",
        isRequired: true,
        terms: `판매 신청한 제품이 안드로이드 폰인 경우 구글, 삼성 계정 삭제, 아이폰인 경우 iCloud 계정 로그아웃을 하지 않은 경우, 안내에 따라 추후 계정 삭제에 협조해야 합니다. 계정 삭제가 되지 않은 경우, 지급된 대금 일부 또는 전부를 환불하는 것에 동의합니다.`,
        isActive: false,
        isCommon: false,
      },
      {
        title: "데이터 완전 삭제 동의",
        isRequired: true,
        terms: `판매 신청한 제품의 모든 데이터를 복원할 수 없도록 삭제하는 것에 동의합니다.`,
        isActive: false,
        isCommon: false,
      },
      {
        title: "중고폰 반환 불가 동의",
        isRequired: true,
        terms: `계좌입력후 중고폰은 민팃(주)에 귀속되어 반환요청이 불가함에 동의합니다.`,
        isActive: false,
        isCommon: false,
      },
      {
        title: "동의 내역 확인",
        isRequired: true,
        terms: `민팃(주)에서 안내하는 내용을 충분히 숙지하고 이에 동의합니다.`,
        isActive: false,
        isCommon: false,
      },
    ],
    isO2otermsContents:[
      {
        title: `계약서 내용에 동의합니다`,
        isRequired: true,
        terms: `<strong>[중고폰 판매 계약]</strong><br><br><strong>제 1조(목적)</strong><br><br>민팃의 서비스를 이용해 주셔서 감사합니다. 본 약관은 다양한 민팃 서비스의 이용과 관련하여 민팃 서비스를 제공하는 민팃 주식회사(이하 “회사”)와 이용자간의 관계를 설명하며, 아울러 “회사”의 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다.
민팃의 서비스를 이용하거나 민팃 서비스 회원으로 가입하실 경우 여러분은 본 약관 및 관련 운영 정책을 확인하거나 동의하게 되므로, 잠시 시간을 내시어 주의 깊게 살펴봐 주시기 바랍니다. · · · <span style="color:#999;">[이하 전문은 <u>자세히 보기</u>에서 확인]</span>`,
        isActive: false,
        isCommon: true,
        isDetaill: true,
        detailNum: 100,
      },
      {
        title: "개인정보 수집 및 이용에 동의합니다",
        isRequired: true,
        terms: `<strong>[개인정보 수집 및 이용 동의]</strong><br><br>
                <strong>“일일 민팃”</strong>과 관련하여, 본인의 개인정보를 민팃(주)가 수집 및 이용하는 것에 대해 동의합니다.<br><br>
                • 개인정보의 수집 및 이용 목적 : 중고폰 판매에 따른 대금 지급<br>
                • 개인정보의 수집 항목 :<br>
                &nbsp;&nbsp;&nbsp;&nbsp;(필수) 이름, 은행명, 계좌번호<br>
                • 개인정보의 보유 기간 : 거래 완료 후 5년(단 법령에 따라 정한 경우에는 해당 기간까지)<br><br>
                ※ 이 내용은 중고폰 대금 지급을 위한 개인정보 수집·이용에 대한 동의입니다. 동의를 거부할 권리가 있으나, 동의하지 않을 경우에 중고폰 판매가 불가할 수 있습니다.`,
        isActive: false,
        isCommon: true,
      },
      {
        title: `중고폰 반품 불가에 동의합니다`,
        isRequired: true,
        terms: `<strong>[중고폰 반품 불가 동의]</strong><br><br> • 계좌번호 입력 후 중고폰은 민팃(주)에 귀속되어 반품 신청이 불가함에 동의합니다.`,
        isActive: false,
        isCommon: true,
      },
    ]
  }),
  mounted() {
    this.bindDetailClick();
  },
  computed: {
    isAgreedAll() {
      const requiredCnt = this.getTermsContents.filter(
        (obj) => obj.isRequired
      ).length;
      const agreedCnt = this.getTermsContents.filter(
        (obj) => obj.isActive
      ).length;
      return requiredCnt === agreedCnt;
    },
    getTermsContents() {
      if(!this.isO2o){
      return this.termsContents.filter((obj) => {
        if (this.ordInfo.isPhone) {
          return true;
        } else {
          return obj.isCommon;
        }
      });
    }else{
      return this.isO2otermsContents.filter((obj) => {
        if (this.ordInfo.isPhone) {
          return true;
        } else {
          return obj.isCommon;
        }
      });
    }
    }
  },
  created() {},
  mounted() {},
  watch: {
    isAgreedAll(newVal) {
      this.allAgrm = newVal;
    },
    allAgrm(newVal) {
      this.$emit("aggreAllAgrm", newVal);
    },
  },
  methods: {
    handleAllAgrm(e) {
      const { value, event } = e;
      if(!this.isO2o){
        this.termsContents = this.termsContents.map((obj) => {
        return {
          ...obj,
          isActive: !event ? obj.isActive : value,
        };
      });
      }else{
        this.isO2otermsContents = this.isO2otermsContents.map((obj) => {
        return {
          ...obj,
          isActive: !event ? obj.isActive : value,
        };
      });
      }

      
    },
    openDetailPopup(e) {
      this.$modal.show("termsPopup", {
        data: { kkkk: "lllll" },
      });
    },
    detailPopup(obj) {
      this.$modal.show("detailPopup", {
      detailNum: obj.detailNum
    })
    },
  }
}
</script>

<style>
.terms-contents {
  word-break: break-all; /* 단어 중간이라도 줄바꿈 가능 */
  white-space: normal;   /* 기본 줄바꿈 허용 */
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/components/Terms.vue